module.exports = __webpack_public_path__ + "img/pubTheSungkars.4c6ebe3a.webp";